<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <div class="block_4 flex-col">
        <div class="text-wrapper_1 flex-col">
          <span class="text_7">全维度服务体系</span>
          <span class="text_8">多维生活服务场景便捷你的校园生活~</span>
        </div>
        <div class="text-wrapper_2 flex-row">
          <span class="text_9" :style="{color: select === 1 ? 'rgba(22, 119, 255, 1)' : 'rgba(153, 153, 153, 1)'}" @click="handleChange(1)">食堂经营管理服务</span>
          <span class="text_10" :style="{color: select === 2 ? 'rgba(22, 119, 255, 1)' : 'rgba(153, 153, 153, 1)'}" @click="handleChange(2)">商贸超市管理服务</span>
          <span class="text_11" :style="{color: select === 3 ? 'rgba(22, 119, 255, 1)' : 'rgba(153, 153, 153, 1)'}" @click="handleChange(3)">商业体管理服务</span>
          <span class="text_12" :style="{color: select === 4 ? 'rgba(22, 119, 255, 1)' : 'rgba(153, 153, 153, 1)'}" @click="handleChange(4)">后勤管理服务</span>
          <span class="text_13" :style="{color: select === 5 ? 'rgba(22, 119, 255, 1)' : 'rgba(153, 153, 153, 1)'}" @click="handleChange(5)">掌上校园管理服务</span>
        </div>
        <CanteenManagementServices v-if="select === 1" />
        <SupermarketServices v-else-if="select === 2" />
        <BusinessServices v-else-if="select === 3" />
        <LogisticsServices v-else-if="select === 4" />
        <SmartCampusServices v-else-if="select === 5" />
      </div>
    </div>
  </div>
</template>
<script>
import CanteenManagementServices from '@/views/service_system/components/CanteenManagementServices.vue'
import SupermarketServices from '@/views/service_system/components/SupermarketServices.vue'
import BusinessServices from '@/views/service_system/components/BusinessServices.vue'
import LogisticsServices from '@/views/service_system/components/LogisticsServices.vue'
import SmartCampusServices from '@/views/service_system/components/SmartCampusServices.vue'

export default {
  components: {
    CanteenManagementServices,
    SupermarketServices,
    BusinessServices,
    LogisticsServices,
    SmartCampusServices,
  },
  data() {
    return {
      select: 1,
      constants: {}
    };
  },
  mounted() {
    if (this.$route.query?.select) {
      this.select = Number(this.$route.query?.select)
    }
  },
  methods: {
    handleChange(value) {
      this.select = value;
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
